import MainLayout from '@/layouts/MainLayout';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import History from '@/pages/about/HistoryPages';
import StrukturOrganisasiPage from '@/pages/about/StrukturOrganisasi';
import VisiMisi from '@/pages/about/VisiMisiPage';
import KarirIndex from '@/pages/career/CareerPage';
import ErrorPage from '@/pages/error/ErrorPage';
import Home from '@/pages/home/HomePage';
import KebijakanPrivasi from '@/pages/kebijakan_privasi';
import BeritaDetailPage from '@/pages/news/NewsDetailPage';
import BeritaListPage from '@/pages/news/NewsListPage';
import ProductServiceDetail from '@/pages/produk_layanan/service';
import ProductServiceItemDetail from '@/pages/produk_layanan/service/item';
import RateLimitPage from '@/pages/RateLimitPage';
import { useApiErrorStore } from '@/stores/apiErrorStore';
import { useEffect } from 'react';

export default function AppRouter() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  const { type } = useApiErrorStore((state) => state);

  // Redirect otomatis ke /rate-limit jika terjadi 429
  if (type === 'RATE_LIMIT') {
    return <RateLimitPage />;
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="tentang-kami">
          <Route path="profil">
            <Route path="sejarah" element={<History />} />
            <Route path="visi-misi" element={<VisiMisi />} />
            <Route path="struktur-organisasi" element={<StrukturOrganisasiPage />} />
          </Route>
        </Route>
        <Route path="produk-layanan">
          <Route index element={<Navigate to="/404" replace />} />
          <Route path=":slug" element={<ProductServiceDetail />}>
            <Route path=":item" element={<ProductServiceItemDetail />} />
          </Route>
        </Route>
        <Route path="berita">
          <Route index element={<BeritaListPage />} />
          <Route path=":slug" element={<BeritaDetailPage />} />
        </Route>
        <Route path="karir">
          <Route index element={<KarirIndex />} />
        </Route>
        <Route path="kebijakan-privasi">
          <Route index element={<KebijakanPrivasi />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </MainLayout>
  );
}
